/**
 * Test IDs for QA automation.
 */
export const testIds = {
  dwellTimeUptickFormSave: "dwell-time-uptick-form-save",
} as const;
